import { fr } from "@codegouvfr/react-dsfr"
import Button from "@codegouvfr/react-dsfr/Button"
import { Box, Typography } from "@mui/material"
import type { ILbaItemJobsGlobal } from "shared"
import type { LBA_ITEM_TYPE_OLD } from "shared/constants/lbaitem"
import { LBA_ITEM_TYPE } from "shared/constants/lbaitem"
import { LiveStatus } from "@/app/_components/LiveStatus"
import { useLocalStorage } from "@/app/hooks/use-local-storage"
import { SendPlausibleEvent } from "@/utils/plausible"

interface GoingToContactQuestionProps {
  kind: LBA_ITEM_TYPE
  item: ILbaItemJobsGlobal
}

const GoingToContactQuestion = ({ kind, item }: GoingToContactQuestionProps) => {
  const { storedValue, setLocalStorage } = useLocalStorage(getGoingtoId(kind, item))

  const workplace = kind === LBA_ITEM_TYPE.FORMATION ? "cet établissement" : "cette entreprise"

  const getType = () => {
    if (kind === LBA_ITEM_TYPE.FORMATION) {
      return "formation"
    }
    return "entreprise Algo"
  }

  const typeForEventTracking = getType()

  return (
    <Box
      sx={{
        mt: fr.spacing("6v"),
        p: fr.spacing("2v"),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        backgroundColor: "white",
        mx: { xs: 0, md: "auto" },
      }}
      data-testid="GoingToContactQuestion"
    >
      <Typography sx={{ fontWeight: 700 }}>Allez-vous contacter {workplace} ?</Typography>
      {/* Déjà rempli au chargement si la réponse est enregistrée : seul le changement au clic est annoncé. */}
      <LiveStatus message={storedValue ? "Merci pour votre réponse !" : ""} />
      {storedValue ? (
        <Typography sx={{ fontWeight: 700 }}>
          Merci pour votre réponse ! <span aria-hidden="true">👌</span>
        </Typography>
      ) : (
        <>
          <Button
            type="button"
            priority="tertiary no outline"
            onClick={() => {
              setLocalStorage(true)
              SendPlausibleEvent(`Clic Je vais contacter - Fiche ${typeForEventTracking}`, {
                info_fiche: item.id,
              })
            }}
          >
            <span aria-hidden="true">👍</span> Oui
          </Button>
          <Button
            type="button"
            priority="tertiary no outline"
            onClick={() => {
              setLocalStorage(true)
              SendPlausibleEvent(`Clic Je ne vais pas contacter - Fiche ${typeForEventTracking}`, {
                info_fiche: item.id,
              })
            }}
          >
            <span aria-hidden="true">👎</span> Non
          </Button>
        </>
      )}
    </Box>
  )
}

export function getGoingtoId(kind: LBA_ITEM_TYPE_OLD | LBA_ITEM_TYPE, item: ILbaItemJobsGlobal) {
  return `goingto-${kind}-${item.id}`
}

export default GoingToContactQuestion
